import { useTranslation } from '@exam-room/translations';

import { Button, LoadingSpinner, Modal, type ModalProps } from '../../../components';

type ExamSubmissionConfirmationModalProps = Omit<ModalProps, 'children'> & {
  onSubmitExam: () => void;
  submitting: boolean;
};

export default function ExamSubmissionConfirmationModal({
  open,
  onClose,
  onSubmitExam,
  submitting: isSubmitting,
}: Readonly<ExamSubmissionConfirmationModalProps>) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      disableClose={isSubmitting}
      className='grid max-w-2xl gap-6'
    >
      <h3>{t('examSubmissionConfirmationModal.title')}</h3>
      <p className='font-normal'>
        {t('examSubmissionConfirmationModal.description.1')}
        <span className='font-semibold'>{t('examSubmissionConfirmationModal.description.2')}</span>
        <br />
        {t('examSubmissionConfirmationModal.description.3')}
      </p>
      <div className='flex justify-end gap-3'>
        <Button variant='outlined' onClick={onClose} disabled={isSubmitting}>
          {t('examSubmissionConfirmationModal.cancel')}
        </Button>
        <Button className='w-[100px] text-black' onClick={onSubmitExam} disabled={isSubmitting}>
          {isSubmitting ? <LoadingSpinner /> : t('examSubmissionConfirmationModal.submit')}
        </Button>
      </div>
    </Modal>
  );
}
